import { Link } from "react-router-dom";
import { ItemRouteProps } from "../types";

const RouteItemHander = ({ toPage, title }: ItemRouteProps) => {
  return (
    <li className='nav-item me-3 m-0 p-0 '>
      <Link
        className='nav-link active text-navbar'
        aria-current='page'
        to={toPage}
      >
        {title}
      </Link>
    </li>
  );
};

export default RouteItemHander;
